// Client-side Spam folder support for the mailbox.
//
// A set of default "spam rules" (sender/subject patterns). Any inbox message
// whose sender or subject matches one of these is treated as Spam — it's hidden
// from the Inbox and shown in the Spam folder instead. The rules are editable
// and persisted per browser; a few seeded spam emails are shown so the folder
// isn't empty out of the box.

export const DEFAULT_SPAM_RULES = [
  'lottery', 'you have won', 'winner', 'congratulations you', 'claim your prize',
  'prize', 'inheritance', 'nigerian prince', 'wire transfer', 'bitcoin', 'crypto',
  'viagra', 'get rich', 'free money', 'act now', 'limited time offer',
  'work from home', 'earn $$$', 'risk-free', 'no-reply@promo', 'promo@',
  'deals@', 'offers@', 'marketing@', '@lottery', '@spammer', '@spam.',
  'unsubscribe now', 'click here to claim', 'verify your account now',
];

const RULES_KEY = 'em-spam-rules';

export function loadSpamRules() {
  try {
    const v = JSON.parse(localStorage.getItem(RULES_KEY) || 'null');
    if (Array.isArray(v) && v.length) return v;
  } catch { /* ignore */ }
  return DEFAULT_SPAM_RULES;
}

export function saveSpamRules(rules) {
  try { localStorage.setItem(RULES_KEY, JSON.stringify(rules)); } catch { /* ignore */ }
}

// True if a message matches any spam rule (by sender address/name or subject).
export function isSpam(msg, rules = DEFAULT_SPAM_RULES) {
  if (!msg) return false;
  const hay = `${msg.from_address || ''} ${msg.from_display || msg.from_name || ''} ${msg.subject || ''}`.toLowerCase();
  return (rules || []).some(r => r && hay.includes(String(r).toLowerCase()));
}

const hoursAgo = h => {
  try { return new Date(Date.now() - h * 3600000).toISOString(); } catch { return ''; }
};

// Seeded demo spam so the Spam folder has content immediately.
export const SPAM_SEED = [
  {
    id: 'spam-seed-1', message_id: 'spam-seed-1',
    from_address: 'winner@lottery-intl.com', from_display: 'International Lottery Board',
    subject: '🎉 Congratulations! You have WON $1,000,000',
    body_text: 'Dear Lucky Winner,\n\nYour email address was selected in our international lottery draw and you have WON $1,000,000. To claim your prize, reply immediately with your full name, address and bank details.\n\nAct now — this limited time offer expires soon!',
    received_at: hoursAgo(2), is_read: false, is_spam: true, is_flagged: false, is_starred: false, has_attachments: false,
  },
  {
    id: 'spam-seed-2', message_id: 'spam-seed-2',
    from_address: 'promo@cheap-deals-now.biz', from_display: 'Mega Deals',
    subject: 'Act now: 90% OFF everything — limited time offer!',
    body_text: 'Get rich quick with our exclusive risk-free deals. Click here to claim your discount before it is gone. Free money and prizes await!',
    received_at: hoursAgo(6), is_read: false, is_spam: true, is_flagged: false, is_starred: false, has_attachments: false,
  },
  {
    id: 'spam-seed-3', message_id: 'spam-seed-3',
    from_address: 'security@verify-account-alert.net', from_display: 'Account Security',
    subject: 'Verify your account now to avoid suspension',
    body_text: 'We detected unusual activity. Verify your account now by clicking the link and entering your password, or your account will be suspended.',
    received_at: hoursAgo(20), is_read: true, is_spam: true, is_flagged: false, is_starred: false, has_attachments: false,
  },
  {
    id: 'spam-seed-4', message_id: 'spam-seed-4',
    from_address: 'prince.money@inheritance-fund.org', from_display: 'Barrister Johnson',
    subject: 'Urgent: Inheritance fund transfer of $10.5M',
    body_text: 'I am a barrister handling an unclaimed inheritance of $10.5 million. I need your help with the wire transfer and will share 40%. Please reply with your bank details.',
    received_at: hoursAgo(30), is_read: false, is_spam: true, is_flagged: false, is_starred: false, has_attachments: false,
  },
];
